import { routes } from './routes';
import { history } from './history';

export const redirectRoute = (to: string) => history.push(routes[to] || to);

export const goBack = () => history.goBack();
